import axios from "axios";

// Config
import { config } from "../config";

async function getPluginsByCategory(categoryId) {
  const categoryUrl = `${config.apiUrl}/api/v1/plugin-category-management/categories/${categoryId}/route`;

  try {
    const catgoryResp = await axios.get(categoryUrl);

    const pluginUrl = `${config.apiUrl}${catgoryResp?.data?.pathPrefix}/providers?enabledOnly=false`;

    const resp = await axios.get(pluginUrl);
    return resp;
  } catch (error) {
    return error;
  }
}

async function getPluginsDetails(pluginId) {
  const url = `${config.apiUrl}/api/plugins-mgmt/plugins/${pluginId}`;

  try {
    const resp = await axios.get(url);
    return resp;
  } catch (error) {
    return error;
  }
}

async function updatePluginStatus(enabled, pluginId) {
  const url = `${config.apiUrl}/api/v1/plugin-categories/signing/providers/${pluginId}/activation`;

  try {
    const resp = await axios.put(url, {
      enabled,
    });
    return resp;
  } catch (error) {
    return error;
  }
}

async function updatePluginCustomerPreviewDetails(data, pluginId) {
  const url = `${config.apiUrl}/api/plugins-mgmt/plugins/${pluginId}/preview`;

  try {
    const resp = await axios.put(url, {
      ...data,
    });
    return resp;
  } catch (error) {
    return error;
  }
}

async function getQESProviders() {
  const url = `${config.apiUrl}/qes/providers`;

  try {
    const resp = await axios.get(url);
    return resp;
  } catch (error) {
    return error;
  }
}

export const pluginsService = {
  getPluginsByCategory,
  getPluginsDetails,
  updatePluginStatus,
  updatePluginCustomerPreviewDetails,
  getQESProviders,
};
